import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { ProcessMicroPaymentDto } from 'src/api/paymentService/dto/ProcessMicroPayment.dto';
import { postMicroPaymentProcess } from 'src/api/paymentService/requests';
import { PaymentProcessResponse } from 'src/api/paymentService/types';

export const usePostMicroPaymentProcess = () =>
    useMutation<PaymentProcessResponse, AxiosError, ProcessMicroPaymentDto>({
        mutationKey: ['process-micro-payment'],
        mutationFn: (payload) => postMicroPaymentProcess(payload),
    });
